export enum PaperFormat {
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  A6 = 'A6',
  LETTER = 'Letter',
  LEGAL = 'Legal',
  TABLOID = 'Tabloid'
}

export const PaperFormatTextMap = {
  [PaperFormat.A3]: 'A3',
  [PaperFormat.A4]: 'A4',
  [PaperFormat.A5]: 'A5',
  [PaperFormat.A6]: 'A6',
  [PaperFormat.LETTER]: '信纸',
  [PaperFormat.LEGAL]: '法律专用纸',
  [PaperFormat.TABLOID]: '小报'
}

export const PaperFormatValueMap = {
  [PaperFormat.A3]: {
    width: '29.72cm',
    height: '41.91cm'
  },
  [PaperFormat.A4]: {
    width: '21.08cm',
    height: '29.72cm'
  },
  [PaperFormat.A5]: {
    width: '14.73cm',
    height: '21.08cm'
  },
  [PaperFormat.A6]: {
    width: '10.41cm',
    height: '14.73cm'
  },
  [PaperFormat.LETTER]: {
    width: '21.59cm',
    height: '27.94cm'
  },
  [PaperFormat.LEGAL]: {
    width: '21.59cm',
    height: '35.56cm'
  },
  [PaperFormat.TABLOID]: {
    width: '27.94cm',
    height: '43.18cm'
  }
}
